/**
 * Get CSS variable value.
 * @param {string} name - CSS variable name.
 * @returns {string} CSS variable value.
 */
export const getCssVar = (name) => {
  return getComputedStyle(document.documentElement).getPropertyValue(name);
};
